var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"l-footer"},[_c('footer-page-top'),_c('footer-navigation'),_c('footer-sp-navigation'),_c('footer-bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }